import React from 'react';
import { BrowserRouter as Router, Routes , Route } from 'react-router-dom';
import appRoutes from "./Routes";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
      <Router>
        <Routes>
          {
            appRoutes.map (route=>(
                <Route key={route.pageId} exact path={route.path} element={route.component} />
            ))
          }
        </Routes>
      </Router>
  );
}

export default App;
